import { MapPin, BadgeCheck } from "lucide-react";
import { SITE, waLink } from "../data/site";
import { Overline, SectionTitle, Accent, Reveal } from "./Reveal";

export const AboutTeam = () => (
  <section className="relative py-24 sm:py-32 bg-[#061A14] overflow-hidden" data-testid="about-team-section">
    <div className="absolute -top-24 right-0 w-[420px] h-[420px] rounded-full bg-[#00E676]/8 blur-[130px]" />
    <div className="relative max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <Reveal>
        <div className="relative max-w-md mx-auto lg:mx-0">
          <div className="absolute -inset-4 rounded-[2.2rem] bg-[#00E676]/15 blur-3xl" />
          <div className="relative rounded-[2rem] overflow-hidden border border-[#00E676]/25 shadow-2xl rotate-[-1.5deg] transition-transform duration-500 hover:rotate-0">
            <img
              src={SITE.photo}
              alt={`${SITE.licenciado} · ${SITE.grupo}`}
              className="w-full aspect-square object-cover"
              data-testid="about-team-photo"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#04120E]/95 to-transparent px-6 pt-16 pb-5">
              <p className="font-heading font-bold text-white text-lg leading-tight">{SITE.licenciado}</p>
              <p className="text-xs text-emerald-100/70 mt-1 inline-flex items-center gap-1.5">
                <MapPin size={12} className="text-[#00E676]" /> {SITE.grupo} · {SITE.cidade}
              </p>
            </div>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.12}>
        <Overline>Quem te atende</Overline>
        <SectionTitle>
          Aqui você fala <Accent>com a gente</Accent>, do começo ao fim.
        </SectionTitle>
        <p className="mt-5 max-w-lg text-sm sm:text-base text-emerald-100/60 leading-relaxed">
          Somos <strong className="text-white">Lucas Marques e Aline Finger</strong>, do{" "}
          <strong className="text-white">{SITE.grupo}</strong> em {SITE.cidade} — Licenciados Autorizados iGreen Energy
          (ID {SITE.licenciadoId}). Nada de robô ou central de atendimento: você conversa direto com a gente pelo
          WhatsApp, do primeiro "oi" até o desconto aparecer na sua conta.
        </p>
        <div className="mt-7 space-y-3">
          {[
            "Atendimento próximo, no seu ritmo e sem compromisso",
            "Cadastro acompanhado passo a passo pelo WhatsApp",
            "Suporte depois da conexão: a gente continua por aqui",
          ].map((t) => (
            <p key={t} className="flex gap-2.5 items-start text-sm text-emerald-100/70">
              <BadgeCheck size={16} className="text-[#00E676] mt-0.5 shrink-0" /> {t}
            </p>
          ))}
        </div>
        <a
          href="https://wa.me/qr/IQCMGKMELXQZD1"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="about-team-whatsapp-cta"
          className="mt-9 inline-flex items-center gap-2 rounded-full bg-[#00E676] hover:bg-[#00C853] text-[#04120E] font-bold px-7 py-4 shadow-[0_0_26px_rgba(0,230,118,0.4)] transition-[background-color,transform] duration-300 hover:scale-[1.03]"
        >
          Falar com a gente no WhatsApp
        </a>
      </Reveal>
    </div>
  </section>
);
